/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * An AIP or DIP received in the Isolated Zone for reingest
 * @export
 * @interface ReingestRequest
 */
export interface ReingestRequest {
    /**
     * 
     * @type {number}
     * @memberof ReingestRequest
     */
    batchId?: number;
    /**
     * datetime package was selected for reingest
     * @type {Date}
     * @memberof ReingestRequest
     */
    createdAt?: Date;
    /**
     * Highest security grade of any content in the package
     * @type {string}
     * @memberof ReingestRequest
     */
    highestSecurityGrading?: string;
    /**
     * Highest sensisivity classification of any content in the package
     * @type {string}
     * @memberof ReingestRequest
     */
    highestSensitivityClassification?: string;
    /**
     * Identifier of reingest request
     * @type {number}
     * @memberof ReingestRequest
     */
    id?: number;
    /**
     * Identifier of package
     * @type {string}
     * @memberof ReingestRequest
     */
    packageId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReingestRequest
     */
    packageType?: ReingestRequestPackageTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ReingestRequest
     */
    packageVersion?: number;
    /**
     * 
     * @type {string}
     * @memberof ReingestRequest
     */
    status?: ReingestRequestStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof ReingestRequest
     */
    statusUpdatedAt?: Date;
    /**
     * ID of workflow selected for Reingest
     * @type {string}
     * @memberof ReingestRequest
     */
    workflowId?: string;
}


/**
 * @export
 */
export const ReingestRequestPackageTypeEnum = {
    Aip: 'AIP',
    Dip: 'DIP'
} as const;
export type ReingestRequestPackageTypeEnum = typeof ReingestRequestPackageTypeEnum[keyof typeof ReingestRequestPackageTypeEnum];

/**
 * @export
 */
export const ReingestRequestStatusEnum = {
    Received: 'Received',
    Validated: 'Validated',
    Failed: 'Failed',
    InProgress: 'In Progress',
    Rejected: 'Rejected',
    Completed: 'Completed'
} as const;
export type ReingestRequestStatusEnum = typeof ReingestRequestStatusEnum[keyof typeof ReingestRequestStatusEnum];


/**
 * Check if a given object implements the ReingestRequest interface.
 */
export function instanceOfReingestRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ReingestRequestFromJSON(json: any): ReingestRequest {
    return ReingestRequestFromJSONTyped(json, false);
}

export function ReingestRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReingestRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'batchId': !exists(json, 'batch_id') ? undefined : json['batch_id'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'highestSecurityGrading': !exists(json, 'highest_security_grading') ? undefined : json['highest_security_grading'],
        'highestSensitivityClassification': !exists(json, 'highest_sensitivity_classification') ? undefined : json['highest_sensitivity_classification'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'packageId': !exists(json, 'package_id') ? undefined : json['package_id'],
        'packageType': !exists(json, 'package_type') ? undefined : json['package_type'],
        'packageVersion': !exists(json, 'package_version') ? undefined : json['package_version'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusUpdatedAt': !exists(json, 'status_updated_at') ? undefined : (new Date(json['status_updated_at'])),
        'workflowId': !exists(json, 'workflow_id') ? undefined : json['workflow_id'],
    };
}

export function ReingestRequestToJSON(value?: ReingestRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'batch_id': value.batchId,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'highest_security_grading': value.highestSecurityGrading,
        'highest_sensitivity_classification': value.highestSensitivityClassification,
        'id': value.id,
        'package_id': value.packageId,
        'package_type': value.packageType,
        'package_version': value.packageVersion,
        'status': value.status,
        'status_updated_at': value.statusUpdatedAt === undefined ? undefined : (value.statusUpdatedAt.toISOString()),
        'workflow_id': value.workflowId,
    };
}

